import React from 'react';
import { Form } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import MarkdownContent from '../../../../../../../components/MarkdownContent';
import { FormFieldPropType } from '../../../../../types/FormField.types';
import './MarkdownText.less';
export default function MarkdownText(_ref) {
  var field = _ref.field;
  var content = field.content,
    _field$style = field.style,
    style = _field$style === void 0 ? {} : _field$style;
  if (_isEmpty(content)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Form.Field, {
    className: "markdown-text",
    style: style
  }, /*#__PURE__*/React.createElement(MarkdownContent, {
    content: content
  }));
}